<img class="id-photo" *ngIf="resourcePhotoUrl && size" src="{{resourcePhotoUrl}}" [width]="size" [height]="size">
